module.exports = __webpack_public_path__ + "img/4.c30b1ab9.jpg";